import script from "./Edit.vue?vue&type=script&setup=true&lang=js"
export * from "./Edit.vue?vue&type=script&setup=true&lang=js"

import "./Edit.vue?vue&type=style&index=0&id=e5965810&scoped=true&lang=css"

import exportComponent from "H:\\project\\tako\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e5965810"]])

export default __exports__